// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import home from '././pages/home'
import mock from './mock'
import request from '@/http/request'

import Vuex from 'vuex'
Vue.use(Vuex)
import store from './store/index.js'

import ElementUI from 'element-ui';
import locale from 'element-ui/lib/locale/lang/en'
import 'element-ui/lib/theme-chalk/index.css';
Vue.use(ElementUI, { locale });

// 全局过虑器
import filters from './utils/filters'
Vue.use(filters)

// 工具类
import Utils from './utils/utils'
Vue.use(Utils)

// api 接口定义
// import Api from './utils/api_url'
// Vue.use(Api)

// 常量定义
import Cnost from './utils/const'
Vue.use(Cnost)

// 验证权限
import { isAuth } from '@/utils/auth'
Vue.prototype.isAuth  = isAuth;

// 公共样式
import '@/assets/styles/common.css'

Vue.config.productionTip = false

import  VueResource  from 'vue-resource'
import './utils/directives.js'
import './assets/images/icon/iconfont.css'
Vue.use(VueResource)

import axios from 'axios'
Vue.prototype.$axios = axios    //全局注册，使用方法为:this.$axios

import VueDirectiveImagePreviewer from 'vue-directive-image-previewer'
import 'vue-directive-image-previewer/dist/assets/style.css'
Vue.use(VueDirectiveImagePreviewer)

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js